import { INSPECTOR_DEFAULT } from "../../../constants/inspectorConstants";

class Symbol {
  constructor(type, { alias, svgSrc, label, rotable, handles, name = null, variants = null}) {
      this.type = type;
      this.alias = alias || "sin-alias";
      this.svgSrc = svgSrc;
      this.label = label;
      this.rotable = rotable || true;
      this.handles = handles;
      this.variants = variants;

      this.attributes = {
        nombre: { isVisible: false, value: name, label: "Nombre" },
      };      
  }
  

  getInspector() {
      return INSPECTOR_DEFAULT;
  }
}

export default Symbol;